







import { Component, Vue, Prop } from 'vue-property-decorator';
import PortfolioProjectDetails from '@/components/PortfolioProjectDetails.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Portfolio',
    components: {
        PortfolioProjectDetails,
        NotLoggedPanel
    }
})
export default class PortfolioProject extends Vue {
    @Prop() private user!: User;
}
